import API from "@/api/AppealsOrgAPI"
import {idUserForApi} from "@/controllers/UserController";
import store from "@/store";

class AppealOrganizationController {
  constructor() {
    this.api = API;
  }

  _checkId(id, text = 'id cannot be null') {
    if (!id)
      throw new Error(text);
  }

  /**
   *
   * @param { string } id
   * */
  // async getAppeal(id,) {
  //   try {
  //     this._checkId(id);
  //     const res = await this.api.getById(id);
  //     return res.data
  //   } catch (e) {
  //     console.error('error getAppeal ' + e.message)
  //     throw new Error('error getAppeal ' + e.message)
  //   }
  // }

  /**
   *
   * @param { Number | null | undefined } [orgId]
   * */
  async getAppeals(orgId,) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(orgId, 'orgId cannot be null');
      const res = await this.api.get(orgId);
      return res.data
    } catch (e) {
      console.error('error getAppeals ' + e.message)
      throw new Error('error getAppeals ' + e.message)
    }
  }

  async setAppeal(data) {
    try {
      const {org, owner, founder, type, ...payload} = data;
      payload.org = org ? {id: org} : null;
      payload.owner = {id: owner};
      payload.orgType = {id: type};
      payload.founder = {id: founder};
      const res = await this.api.setAppeal(payload);
      await store.dispatch('appeals/pushOrgAppeal', res.data);
      return res.data;
    } catch (e) {
      console.error('error setAppeal ' + e.message)
      throw new Error('error setAppeal ' + e.message)
    }
  }

  /**
   * @param {{
   *     "id": string,
   *   accept: boolean
   * }} data
   * */
  async closeAppeal(data) {
    try {
      const res = await this.api.closeAppeal(data)
      return res.data
    } catch (e) {
      console.error('error closeAppeal ' + e.message)
      throw new Error('error closeAppeal ' + e.message)
    }
  }

  // /**
  //  * @param {string} id
  //  * */
  // async deleteAppeal(id) {
  //   try {
  //     this._checkId(id)
  //     const res = await this.api.deleteAppeal(id)
  //     await store.dispatch('appeals/deleteOrgAppeal', id);
  //     return res.data
  //   } catch (e) {
  //     console.error('error deleteAppeal ' + e.message)
  //     throw new Error('error deleteAppeal ' + e.message)
  //   }
  // }


  async deleteAppeal(id) {
    try {
      this._checkId(id)
      const res = await this.api.deleteAppeal(id)
      await store.dispatch('appeals/deleteOrgAppeal', id);
      return res.data
    } catch (e) {
      console.error('error deleteAppeal ' + e.message)
      throw new Error('error deleteAppeal ' + e.message)
    }
  }

}

export default new AppealOrganizationController();